import { render, staticRenderFns } from "./FilterPrice.vue?vue&type=template&id=772d852a&scoped=true&"
import script from "./FilterPrice.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FilterPrice.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772d852a",
  null
  
)

export default component.exports